import { isMobileApp } from "@airtel-lego/native-app-bridge";
import { CART_CONSTANTS, LOGIN_CONSTANTS } from "../constants/AppConstants";

export const createCartObj = (args: any, onUserAction: any, actionContextData: any, getState: any) => {
    const actions = [];
    const { storeValues } = getState();
    const rtn = actionContextData?.value;
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let utmSource = params.get('utm_source');
    let referralCode = params.get('rC');
    let refRtn = params.get('refRtn');
    const isReferral = utmSource?.toLowerCase()?.includes('referral') && referralCode && refRtn 
    const isCoipUser = !!storeValues?.userData?.isCoipUser;
    const email = storeValues?.userData?.email;
    let apiVersion = (storeValues.versionContextNP2P?.version);
    let intentType = "";
    try {
        let intentData = sessionStorage.getItem("intentSelected") as any
        if (JSON.parse(intentData)?.type?.toLowerCase() === "mnp") intentType = "MNP"
        if (JSON.parse(intentData)?.type?.toLowerCase() === "new-connection") intentType = "NEW_CONNECTION"
    } catch (error) {
        console.log(error)
    }

    let bodyPayload: any = {
        "isCoipUser": isCoipUser,
        "email": email,
        "contactMedium": [
            {
                "mediumType": "alternateNumber",
                "characteristic": {
                    "phoneNumber": rtn
                }
            }
        ],
        "cartItem": [
            {
                "action": "add",
                "quantity": 1,
                "product": {
                    "productCharacteristic": [
                        {
                            "name": "uniqueReferenceId",
                            "value": {
                                "textValue": CART_CONSTANTS.UNIQUE_ID().toString()
                            }
                        },
                        {
                            "name": "productType",
                            "value": {
                                "textValue": CART_CONSTANTS.POSTPAID
                            }
                        }
                    ]
                }
            }
        ]
    }

    if(isReferral){
        bodyPayload?.cartItem?.[0]?.product?.productCharacteristic?.push(
            {
                name: "referrerCode",
                value: {
                    textValue: referralCode
                }
            }
        )

        bodyPayload?.cartItem?.[0]?.product?.productCharacteristic?.push(
            {
                name: "referrerNumber",
                value: {
                    textValue: refRtn
                }
            }
        )
    }

    if (isCoipUser && !!email) {
        bodyPayload?.cartItem?.[0]?.product?.productCharacteristic?.push({
            "name": "productSubSegment",
            "value": {
                "textValue": "BUSINESS"
            }
        });
        bodyPayload?.contactMedium?.push({
            "mediumType": "email",
            "characteristic": {
                "emailAddress": email,
                "emailVerified": "1"
            }
        });
    }

    if (intentType) {
        bodyPayload?.cartItem[0]?.product?.productCharacteristic?.push(
            {
                "name": "orderSubType",
                "value": {
                    "textValue": intentType
                }
            }
        )
    }

    const apiUrl = `guardian/api/buy/postpaid/non-postpaid/createCart/bundling/v${isCoipUser ? '20' : (apiVersion ? apiVersion : '1')}`;
    const isUnAuthUser = storeValues?.analyticsData?.extraData14 && storeValues?.analyticsData?.extraData14 == "Unauth"

    const uqlPayload = {
        type: 'apiCall',
        payload: {
            requestType: 'POST',
            key: "POST",
            apiUrl,
            body: { data: bodyPayload, isHardBundle: storeValues?.packInfo?.bundleType, isAuthFlow: storeValues?.user?.isUserLoggedIn , source: isReferral ? "REFERRAL" : "SHOP",isUnAuthUser},
            queryParams: {
                intentType: intentType
            },
            header: {},
        },
    };

    if (isCoipUser) {
        const isApp = isMobileApp();
        const payloadObj: any = uqlPayload.payload;
        if (isApp) payloadObj.transactUserGroup = LOGIN_CONSTANTS.coipGroupId
        else payloadObj.authTokenGroup = LOGIN_CONSTANTS.coipGroupId
    }


    actions.push(uqlPayload);



    return onUserAction({
        actions
    });
}

export const updateName = (args: any, onUserAction: any, actionContextData: any, getState: any) => {
    const actions = [];
    const { storeValues } = getState();

    let customerName = actionContextData?.name
    let cartId = storeValues?.orderData?.orderData?.cartId || ""
    let cartItemId = storeValues?.orderData?.orderData?.cartItemId || ""
    let isCoipUser = !!(storeValues?.userData?.isCoipUser);
    let apiVersion = (storeValues.versionContextNP2P?.version)
    const variant = (storeValues.variantName?.variant) ?? ""
    if (cartId && cartItemId) {

        const payload = {
            id: cartId,
            channel: [
                {
                    "name": "SHOP"
                }
            ],
            relatedParty: [
                {
                    "name": customerName,
                    "role": "customer"
                }
            ],
            cartItem: [
                {
                    id: cartItemId,
                    action: "add"
                }
            ]

        };

        const apiUrl = `guardian/api/buy/postpaid/non-postpaid/updateCart/bundling/v${isCoipUser ? '20' : (apiVersion ? apiVersion : '1')}`;
        const uqlPayload = {
            type: 'apiCall',
            payload: {
                authTokenGroup: LOGIN_CONSTANTS.authKey,
                requestType: 'POST',
                "key": "POST",
                apiUrl,
                body: { data: payload, isHardBundle: storeValues?.packInfo?.bundleType, isAuthFlow: storeValues?.user?.isUserLoggedIn, operationType: args[0][1], isCoipUser, variant },
                queryParams: {
                    lob: storeValues?.userData?.lob,
                    thanksType: storeValues?.packInfo?.thanksType,
                    omniNewDrop: storeValues?.storeOmniData?.omni_new_drop
                },
                header: {},
            },
        };


        if (isCoipUser) {
            const isApp = isMobileApp();
            const payloadObj: any = uqlPayload.payload;
            isApp ? payloadObj.transactUserGroup = LOGIN_CONSTANTS.coipGroupId : payloadObj.authTokenGroup = LOGIN_CONSTANTS.coipGroupId
        }


        actions.push(uqlPayload);
    }



    actions.push({
        type: 'storeValuesInRedux',
        payload: {
            context: 'user',
            data: {
                name: customerName || "",
            },
        },
    })


    return actions
}

export const createStandaloneQL = (args: any, onUserAction: any, actionContextData: any, getState: any) => {
    const { storeValues } = getState();
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let cartId = storeValues?.orderData?.orderData?.cartId || ""
    let cartItemId = storeValues?.orderData?.orderData?.cartItemId || ""
    let queryId = storeValues?.addressData?.queryId || ""
    // let planId = storeValues?.packInfo?.planId || ""
    // let planName = storeValues?.packInfo?.planName || ""


    //now non p2p plan will be fetched from np2pNewPackInfo
    let planId = storeValues?.np2pNewPackInfo?.planId || ""
    let planName = storeValues?.np2pNewPackInfo?.planName || ""
    let apiVersion = (storeValues.versionContextNP2P?.version);

    let utmSource = params.get('utm_source');
    let referralCode = params.get('rC');
    let refRtn = params.get('refRtn');
    const isReferral = utmSource?.toLowerCase()?.includes('referral') && referralCode && refRtn 

    const isCoipUser = !!storeValues?.userData?.isCoipUser;

    if (isCoipUser) {
        planId = storeValues?.coipDefaultPlan?.planId
        planName = storeValues?.coipDefaultPlan?.planName
    }


    if (cartId && cartItemId) {

        let bodyPayload:any = {};

        let contactMediumArray = [
            {
                mediumType: 'billingAddress',
                "characteristic": {
                    "addressType": "INSTALLATION",
                    "street1": storeValues?.addressData?.street1 || "",
                    "city": storeValues?.addressData?.city || "",
                    "postCode": storeValues?.addressData?.postCode || ""
                }
            }
        ];

        bodyPayload =
        {
            id: cartId,
            channel: [
                {
                    "name": "SHOP"
                }
            ],

            cartItem: [
                {
                    id: cartItemId,
                    productOffering: {
                        id: planId,
                        name: planName,
                    },
                    product: {
                        productCharacteristic: [
                            {
                                name: "uniqueReferenceId",
                                value: {
                                    textValue: CART_CONSTANTS.UNIQUE_ID().toString()
                                }
                            },
                            {
                                name: "productType",
                                value: {
                                    textValue: CART_CONSTANTS.POSTPAID
                                }
                            }
                        ]
                    },
                    action: "add",
                    productOfferingQualificationItem:{
                        id: queryId
                    },
                    contactMedium: contactMediumArray
                }
            ]

        };

        if(isReferral){
            bodyPayload?.cartItem?.[0]?.product?.productCharacteristic?.push(
                {
                    name: "referrerCode",
                    value: {
                        textValue: referralCode
                    }
                }
            )
    
            bodyPayload?.cartItem?.[0]?.product?.productCharacteristic?.push(
                {
                    name: "referrerNumber",
                    value: {
                        textValue: refRtn
                    }
                }
            )
        }

        const apiUrl = `guardian/api/buy/postpaid/non-postpaid/updateCart/bundling/v${isCoipUser ? '20' : (apiVersion ? apiVersion : '1')}`;
        const apiCallObj = {
            type: 'apiCall',
            payload: {
                authTokenGroup: LOGIN_CONSTANTS.authKey,
                requestType: 'POST',
                "key": "POST",
                apiUrl, //update cart
                body: { data: bodyPayload, isHardBundle: storeValues?.packInfo?.bundleType, isAuthFlow: storeValues?.user?.isUserLoggedIn, operationType: args[0][1], isCoipUser },
                header: {},
                queryParams: {
                    isApp: isMobileApp(),
                    thanksType: storeValues?.packInfo?.thanksType,
                    userEnteredValue: storeValues?.userData?.userEnteredValue,
                    omniNewDrop: storeValues?.storeOmniData?.omni_new_drop
                },
            },
        };

        if (isCoipUser) {
            const isApp = isMobileApp();
            const payloadObj: any = apiCallObj.payload;
            isApp ? payloadObj.transactUserGroup = LOGIN_CONSTANTS.coipGroupId : payloadObj.authTokenGroup = LOGIN_CONSTANTS.coipGroupId
        }


        return apiCallObj;

    }

    return null;
}

export const createExistingBundledQL = (args: any, onUserAction: any, actionContextData: any, getState: any, isCoipUser: boolean = false) => {

    const { storeValues, } = getState();
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let utmSource = params.get('utm_source');
    let referralCode = params.get('rC');
    let refRtn = params.get('refRtn');
    const isReferral = utmSource?.toLowerCase()?.includes('referral') && referralCode && refRtn ;
    let cartId = storeValues?.orderData?.orderData?.cartId || ""
    let cartItemId = storeValues?.orderData?.orderData?.cartItemId || ""
    let cartObj = storeValues?.orderData?.orderData?.cartObj
    let customerName = storeValues?.user?.name || ""
    let bundleId = storeValues?.packInfo?.bundleId || ""
    let bundlePlan = storeValues?.packInfo?.bundlePlan || ""
    let bundleType = storeValues?.packInfo?.bundleFamily
    let homesAction = storeValues?.packInfo?.homesAction || ""
    let homesID = storeValues?.packInfo?.homesId || ""
    const rtn = storeValues?.userData?.rtn;
    const services = storeValues?.packInfo?.services || {}
    const circleId = storeValues?.addressData?.circleId || "102"
    // let planId = storeValues?.packInfo?.planId || ""
    // let planName = storeValues?.packInfo?.planName || ""

    // now non p2p plan will be fetched from np2pNewPackInfo
    let planId = storeValues?.np2pNewPackInfo?.planId || ""
    let planName = storeValues?.np2pNewPackInfo?.planName || ""
    let apiVersion = (storeValues.versionContextNP2P?.version);
    let queryId = storeValues?.addressData?.queryId || ""

    let intentType = "";
    try {
        let intentData = sessionStorage.getItem("intentSelected") as any
        if (JSON.parse(intentData)?.type?.toLowerCase() === "mnp") intentType = "MNP"
    } catch (error) {
        console.log(error)
    }

    const newServiceObj = services?.find((el: any) => el?.lob === CART_CONSTANTS.POSTPAID && el.type === "NEW")
    const payload: any = {
        id: cartId,
        bundlingType: homesID ? CART_CONSTANTS.HN : CART_CONSTANTS.EN,
        channel: [
            {
                name: CART_CONSTANTS.CHANNEL_SHOP,
            },
        ],
        cartItemsToBeDeleted: [cartItemId],
        relatedParty: [
            {
                name: customerName,
                role: 'customer',
            },
        ],
        existingServices: getRelatedservices(services, rtn),
        cartItem: [
            {

                productOffering: {
                    id: bundleId,
                    name: bundlePlan,
                },
                action: homesAction,
                quantity: 1,
                product: {
                    productCharacteristic: [
                        {
                            name: 'productType',
                            value: {
                                textValue: CART_CONSTANTS.PRODUCT_SUBTYPE_HOME,
                            },
                        },
                        {
                            name: 'productSubType',
                            value: {
                                textValue: bundleType,
                            },
                        },
                        {
                            name: 'productSegment',
                            value: {
                                textValue: CART_CONSTANTS.PRODUCT_SEGMENT_CONSUMER,
                            },
                        },
                        {
                            name: 'uniqueReferenceId',
                            value: {
                                textValue: CART_CONSTANTS.UNIQUE_ID().toString(),
                            },
                        },
                        {
                            name: 'productSubSegment',
                            value: {
                                textValue: CART_CONSTANTS.PRODUCT_SEGMENT_RETAIL,
                            },
                        },
                        {
                            name: 'circleId',
                            value: {
                                textValue: circleId,
                            },
                        }
                    ],
                },
                cartItem: [
                    {
                        action: 'add',
                        quantity: 1,
                        productOffering: {
                            id: planId,
                            name: planName,
                        },
                        product: {
                            productCharacteristic: [ //TODO: add referral checks here 
                                {
                                    name: 'uniqueReferenceId',
                                    value: {
                                        textValue: CART_CONSTANTS.UNIQUE_ID().toString(),
                                    },
                                },
                                {
                                    name: 'productType',
                                    value: {
                                        textValue: CART_CONSTANTS.POSTPAID,
                                    },
                                },
                                {
                                    name: 'rtn',
                                    value: {
                                        textValue: rtn,
                                    },
                                },
                                {
                                    name: 'circleId',
                                    value: {
                                        textValue: circleId,
                                    },
                                },
                                {
                                    name: 'flexible',
                                    value: {
                                        booleanValue: newServiceObj?.flexible,
                                    },
                                },
                                {
                                    name: 'optional',
                                    value: {
                                        booleanValue: newServiceObj?.optional,
                                    },
                                },
                                {
                                    name: 'bundled',
                                    value: {
                                        booleanValue: newServiceObj?.bundled,
                                    },
                                },
                                {
                                    name: "connectionType",
                                    value: {
                                        textValue: "NEW"
                                    }
                                }
                            ],
                        },
                        productOfferingQualificationItem:{
                            id: queryId
                        },
                        contactMedium: [
                            {
                                mediumType: 'billingAddress',
                                characteristic: {
                                    addressType: 'INSTALLATION',
                                    street1: storeValues?.addressData?.street1 || '',
                                    city: storeValues?.addressData?.city || '',
                                    postCode: storeValues?.addressData?.postCode || '',
                                },
                            },
                        ],
                    },
                ],
            },
        ],
    };

    if(isReferral){
        payload?.cartItem?.[0]?.cartItem?.[0]?.product?.productCharacteristic?.push(
            {
                name: "referrerCode",
                value: {
                    textValue: referralCode
                }
            }
        )

        payload?.cartItem?.[0]?.cartItem?.[0]?.product?.productCharacteristic?.push(
            {
                name: "referrerNumber",
                value: {
                    textValue: refRtn
                }
            }
        )
    }

    if (homesID) {
        payload.cartItem[0].product.realizingResource = [
            {
                "name": "homesId",
                "value": {
                    "textValue": homesID
                }
            }
        ]
    }

    if (intentType) {
        payload?.cartItem[0]?.cartItem[0]?.product?.productCharacteristic?.push(
            {
                name: "orderSubType",
                value: {
                    textValue: intentType
                }
            }
        )
    }

    const apiUrl = `guardian/api/buy/postpaid/non-postpaid/updateCart/bundling/v${isCoipUser ? '20' : (apiVersion ? apiVersion : '1')}`;
    const qlayload: any = {
        type: 'apiCall',
        payload: {
            authTokenGroup: LOGIN_CONSTANTS.authKey,
            requestType: 'POST',
            "key": "POST",
            apiUrl, //update cart
            body: { data: payload, isHardBundle: storeValues?.packInfo?.bundleType, isAuthFlow: storeValues?.user?.isUserLoggedIn, operationType: args[0][1], isCoipUser },
            queryParams: {
                lob: storeValues?.userData?.lob,
                siNumber: rtn,
                thanksType: storeValues?.packInfo?.thanksType,
                omniNewDrop: storeValues?.storeOmniData?.omni_new_drop
            },
            header: {},
        },
    };


    if (isCoipUser) {
        const isApp = isMobileApp();
        if (isApp) qlayload.transactUserGroup = LOGIN_CONSTANTS.coipGroupId;
        else qlayload.authTokenGroup = LOGIN_CONSTANTS.coipGroupId;
    }

    return qlayload
}


const getRelatedservices = (services: any, rtn: string) => {

    let existingServices = [];

    for (let i = 0; i < services?.length; i++) {
        let serviceCartObj: any = {};
        const serviceObj = services[i];

        if (serviceObj?.type == 'EXISTING') {



            if (serviceObj?.lob === CART_CONSTANTS.POSTPAID) {
                serviceCartObj =
                {
                    "action": serviceObj?.action, //action to be coming from reco modify,
                    "product": {
                        "productCharacteristic": [
                            {
                                "name": "uniqueReferenceId",
                                "value": {
                                    "textValue": CART_CONSTANTS.UNIQUE_ID().toString()
                                }
                            },
                            {
                                "name": "productSubType",
                                "value": {
                                    "textValue": CART_CONSTANTS.PRODUCT_SUBTYPE_PRIMARY
                                }
                            },
                            {
                                "name": "productType",
                                "value": {
                                    "textValue": CART_CONSTANTS.POSTPAID
                                }
                            },
                            {
                                "name": "productSegment",
                                "value": {
                                    "textValue": CART_CONSTANTS.PRODUCT_SEGMENT_CONSUMER
                                }
                            },
                            {
                                "name": "productSubSegment",
                                "value": {
                                    "textValue": CART_CONSTANTS.PRODUCT_SEGMENT_RETAIL
                                }
                            },
                            {
                                "name": "rtn",
                                "value": {
                                    "textValue": rtn
                                }
                            },
                            {
                                "name": "flexible",
                                "value": {
                                    "booleanValue": serviceObj?.flexible
                                }
                            },
                            {
                                "name": "optional",
                                "value": {
                                    "booleanValue": serviceObj?.optional
                                }
                            },
                            {
                                "name": "bundled",
                                "value": {
                                    "booleanValue": serviceObj?.bundled
                                }
                            }

                        ],
                        "realizingResource": [
                            {
                                "name": "siNumber",
                                "value": {
                                    "textValue": serviceObj?.siNumber
                                }
                            }
                        ]
                    }
                }

            }
            else if (serviceObj?.lob === 'TELEMEDIA') {
                serviceCartObj =
                {
                    "action": serviceObj?.action,
                    "quantity": 1,
                    "product": {
                        "productCharacteristic": [
                            {
                                "name": "uniqueReferenceId",
                                "value": {
                                    "textValue": CART_CONSTANTS.UNIQUE_ID().toString()
                                }
                            },
                            {
                                "name": "productType",
                                "value": {
                                    "textValue": CART_CONSTANTS.TELEMEDIA
                                }
                            },
                            {
                                "name": "productSegment",
                                "value": {
                                    "textValue": CART_CONSTANTS.PRODUCT_SEGMENT_CONSUMER
                                }
                            },
                            {
                                "name": "productSubSegment",
                                "value": {
                                    "textValue": CART_CONSTANTS.PRODUCT_SEGMENT_RETAIL
                                }
                            },
                            {
                                "name": "rtn",
                                "value": {
                                    "textValue": rtn
                                }
                            },
                            {
                                "name": "flexible",
                                "value": {
                                    "booleanValue": serviceObj?.flexible
                                }
                            },
                            {
                                "name": "optional",
                                "value": {
                                    "booleanValue": serviceObj?.optional
                                }
                            },
                            {
                                "name": "bundled",
                                "value": {
                                    "booleanValue": serviceObj?.bundled
                                }
                            }

                        ],
                        "realizingResource": [
                            {
                                "name": "siNumber",
                                "value": {
                                    "textValue": serviceObj?.siNumber
                                }
                            }
                        ]
                    }

                }
            }
            else if (serviceObj?.lob === CART_CONSTANTS.DTH) {
                serviceCartObj =
                {
                    "action": serviceObj?.action,
                    "quantity": 1,
                    "product": {

                        "productCharacteristic": [
                            {
                                "name": "uniqueReferenceId",
                                "value": {
                                    "textValue": CART_CONSTANTS.UNIQUE_ID().toString()
                                }
                            },

                            {
                                "name": "productType",
                                "value": {
                                    "textValue": CART_CONSTANTS.DTH
                                }
                            },
                            {
                                "name": "productSegment",
                                "value": {
                                    "textValue": CART_CONSTANTS.PRODUCT_SEGMENT_CONSUMER
                                }
                            },
                            {
                                "name": "productSubSegment",
                                "value": {
                                    "textValue": CART_CONSTANTS.PRODUCT_SEGMENT_RETAIL
                                }
                            },
                            {
                                "name": "rtn",
                                "value": {
                                    "textValue": rtn
                                }
                            },
                            {
                                "name": "flexible",
                                "value": {
                                    "booleanValue": serviceObj?.flexible
                                }
                            },
                            {
                                "name": "optional",
                                "value": {
                                    "booleanValue": serviceObj?.optional
                                }
                            },
                            {
                                "name": "bundled",
                                "value": {
                                    "booleanValue": serviceObj?.bundled
                                }
                            }

                        ],
                        "realizingResource": [
                            {
                                "name": "siNumber",
                                "value": {
                                    "textValue": serviceObj?.siNumber
                                }
                            }
                        ]
                    }

                }

            }
            existingServices.push(serviceCartObj)
        }

    }
    return existingServices;
}


export const handleBundledFlowLogic = (args: any, onUserAction: any, actionContextData: any, getState: any) => {
    let actions = [] as Array<object>;
    const { storeValues } = getState();
    const thanksType = storeValues?.packInfo?.thanksType;
    const pincodeList = storeValues?.pinCodesForBundling?.pincodeList || [];
    const pinCodeSubmitted = storeValues?.addressData?.postCode as string;
    const isCoipUser = !!storeValues?.userData?.isCoipUser;
    let obj: any = {}
    if (args[0][1] === 'address') {
        if (pincodeList?.length > 0) {
            if (pincodeList?.includes(pinCodeSubmitted)) {
                if (thanksType === 'OFFER_USP') {
                    obj = { ...createExistingBundledQL(args, onUserAction, actionContextData, getState, isCoipUser) }
                } else {
                    obj = { ...createStandaloneQL(args, onUserAction, actionContextData, getState) }
                    const actionObj =
                    {
                        type: 'storeValuesInRedux',
                        payload: {
                            context: 'packInfo',
                            data: {
                                thanksType: ""
                            },
                        }
                    }
                    actions?.push(actionObj)
                }
            } else {
                obj = { ...createStandaloneQL(args, onUserAction, actionContextData, getState) }
                // return action to set thanksType as null
                const actionObj =
                {
                    type: 'storeValuesInRedux',
                    payload: {
                        context: 'packInfo',
                        data: {
                            thanksType: ""
                        },
                    }
                }
                actions?.push(actionObj)
            }
        } else {
            //here add coip logic
            if (thanksType === 'OFFER_USP') {
                obj = { ...createExistingBundledQL(args, onUserAction, actionContextData, getState, isCoipUser) }
            } else {
                obj = { ...createStandaloneQL(args, onUserAction, actionContextData, getState) }
            }
        }

        if (obj) {
            actions?.push(obj);
        }

    }
    else if (args[0][1] === 'name') {
        actions = [...updateName(args, onUserAction, actionContextData, getState)]
    }

    return onUserAction({
        actions
    });
}


/**
 * create bundle QL for N+N case
 * @param args
 * @param actionContextData
 * @param onUserAction
 * @param getState
 */
export const createBundleQLNN = (
    args: any,
    actionContextData: any,
    onUserAction: any,
    getState: any
) => {
    const { storeValues } = getState();
    const { dthWidgetAddressDetails, broadbandWidgetAddressDetails, additionalData, userData } = storeValues;

    const { queryParams } = additionalData

    const circleId = queryParams?.lob?.toUpperCase() === "DTH" ? dthWidgetAddressDetails?.widgetData?.pinCodeDetails?.circleId : "102"
    const widgetAddressDetails = queryParams?.lob?.toUpperCase() === "DTH" ? dthWidgetAddressDetails : broadbandWidgetAddressDetails

    const actions = [];

    let cartId = storeValues?.orderData?.orderData?.cartId || ""
    let cartItemId = storeValues?.orderData?.orderData?.cartItemId || ""
    let customerName = storeValues?.user?.name || ""
    let bundleId = storeValues?.packInfo?.bundleId || ""
    let bundlePlan = storeValues?.packInfo?.bundlePlan || ""
    let bundleType = storeValues?.packInfo?.bundleFamily
    let homesAction = storeValues?.packInfo?.homesAction || ""
    let standAloneId = storeValues?.serviceDetails?.planId || ""
    let standAloneName = storeValues?.serviceDetails?.shortTitle || ""
    const services = storeValues?.packInfo?.services || {}
    let queryId = widgetAddressDetails?.lob === CART_CONSTANTS.TELEMEDIA ? broadbandWidgetAddressDetails?.widgetData?.queryId : ""

    let widgetData = widgetAddressDetails?.widgetData || {}
    let broadbandRSU = widgetData?.rsu || ""
    let maxBandwidth = widgetData?.maxBandwidth || ""
    let networkName = widgetData?.neName || ""
    let addressBB = widgetData?.address || {}
    let latitude = addressBB?.latitude || ""
    let longitude = addressBB?.longitude || ""
    let city = addressBB?.city || ""
    let feasibilityScore = widgetData?.feasibilityScore || ""
    let feasibilitySource = "DIGITAL_STORE_FWA"
    let apiVersion = (storeValues.versionContextNP2P?.version);

    const telemediaDetails = [
        {
            name: "rsu",
            value: {
                textValue: broadbandRSU
            }
        },
        {
            name: "maxBandwidth",
            value: {
                textValue: maxBandwidth
            }
        },
        {
            name: "city",
            value: {
                textValue: city
            }
        },
        {
            name: "neName",
            value: {
                textValue: networkName
            }
        },
        {
            name: "latitude",
            value: {
                textValue: latitude
            }
        },
        {
            name: "longitude",
            value: {
                textValue: longitude
            }
        },
        {
            name: "feasibilityScore",
            value: {
                textValue: feasibilityScore
            }
        },
        {
            name: "feasibilitySource",
            value: {
                textValue: feasibilitySource
            }
        }

    ]

    const dthDetails = [
        {
            name: "deviceType",
            value: {
                textValue: "NA"
            }
        },
        {
            name: "deviceCategory",
            value: {
                textValue: "NA"
            }
        }
    ]



    const newServiceObj = services?.find((el: any) => el?.lob === widgetAddressDetails?.lob && el.type === "NEW")
    const postpaidObj = services?.find((el: any) => el?.lob === CART_CONSTANTS.POSTPAID && el.type === "NEW")

    const bundlePayload = {
        id: cartId,
        bundlingType: CART_CONSTANTS.NN,
        cartItemsToBeMerged: [cartItemId],
        cartItemsToBePatched: {
            [cartItemId]: {
                product: {
                    productCharacteristic: [
                        {
                            name: 'flexible',
                            value: {
                                booleanValue: postpaidObj?.flexible,
                            },
                        },
                        {
                            name: 'optional',
                            value: {
                                booleanValue: postpaidObj?.optional,
                            },
                        },
                        {
                            name: 'bundled',
                            value: {
                                booleanValue: postpaidObj?.bundled,
                            },
                        }
                    ]
                }
            }
        },
        channel: [
            {
                name: CART_CONSTANTS.CHANNEL_SHOP,
            },
        ],
        relatedParty: [
            {
                name: customerName,
                role: 'customer',
            },
        ],
        cartItem: [
            {
                productOffering: {
                    id: bundleId,
                    name: bundlePlan,
                },
                action: homesAction,
                product: {
                    productCharacteristic: [
                        {
                            name: 'productType',
                            value: {
                                textValue: CART_CONSTANTS.PRODUCT_SUBTYPE_HOME,
                            },
                        },
                        {
                            name: 'productSubType',
                            value: {
                                textValue: bundleType
                            },
                        },
                        {
                            name: 'productSegment',
                            value: {
                                textValue: CART_CONSTANTS.PRODUCT_SEGMENT_CONSUMER,
                            },
                        },
                        {
                            name: 'uniqueReferenceId',
                            value: {
                                textValue: CART_CONSTANTS.UNIQUE_ID().toString(),
                            },
                        },
                        {
                            name: 'productSubSegment',
                            value: {
                                textValue: CART_CONSTANTS.PRODUCT_SEGMENT_RETAIL,
                            },
                        },
                        {
                            name: 'circleId',
                            value: {
                                textValue: circleId,
                            },
                        }
                    ],
                },
                cartItem: [
                    {
                        //coming from offer engine
                        productOffering: {
                            id: standAloneId,
                            name: standAloneName
                        },
                        action: 'add',
                        product: {
                            productCharacteristic: [
                                {
                                    name: 'productType',
                                    value: {
                                        textValue: `${widgetAddressDetails?.lob}`,
                                    },
                                },
                                {
                                    name: 'productSegment',
                                    value: {
                                        textValue: CART_CONSTANTS.PRODUCT_SEGMENT_CONSUMER,
                                    },
                                },
                                {
                                    name: 'circleId',
                                    value: {
                                        textValue: circleId,
                                    },
                                },
                                {
                                    name: 'uniqueReferenceId',
                                    value: {
                                        textValue: CART_CONSTANTS.UNIQUE_ID().toString(),
                                    },
                                },
                                {
                                    name: 'productSubSegment',
                                    value: {
                                        textValue: CART_CONSTANTS.PRODUCT_SEGMENT_RETAIL,
                                    },
                                },
                                {
                                    name: 'rtn',
                                    value: {
                                        textValue: `${userData?.rtn}`,
                                    },
                                },
                                {
                                    name: 'flexible',
                                    value: {
                                        booleanValue: newServiceObj?.flexible,
                                    },
                                },
                                {
                                    name: 'optional',
                                    value: {
                                        booleanValue: newServiceObj?.optional,
                                    },
                                },
                                {
                                    name: 'bundled',
                                    value: {
                                        booleanValue: newServiceObj?.bundled,
                                    },
                                },
                                {
                                    name: "connectionType",
                                    value: {
                                        textValue: "NEW"
                                    }
                                }
                            ]
                        },
                        productOfferingQualificationItem:{
                            id: queryId
                        },
                        contactMedium: [
                            {
                                mediumType: 'installationAddress',
                                characteristic: createInstallationAddress(widgetAddressDetails),
                            },
                        ],
                    },
                ],
            },
        ],
    };


    if (widgetAddressDetails?.lob === CART_CONSTANTS.TELEMEDIA) {
        console.log("in case of telemedia only");
        bundlePayload.cartItem[0].cartItem[0].product.productCharacteristic.push(...telemediaDetails)
    }
    if (widgetAddressDetails?.lob === CART_CONSTANTS.DTH) {
        console.log("in case of dth only")
        bundlePayload.cartItem[0].cartItem[0].product.productCharacteristic.push(...dthDetails)
    }



    actions.push({
        payload: {
            authTokenGroup: LOGIN_CONSTANTS.authKey,
            requestType: 'POST',
            apiUrl: `guardian/api/buy/postpaid/non-postpaid/updateCart/bundling/v${apiVersion ? apiVersion : '1'}`,
            body: {
                data: bundlePayload,
                operationType: 'thankYouPage',
                thanksType: 'OFFER_BENEFIT_USP',
                offerAmount: storeValues?.packInfo?.offerAmount,
                omniNewDrop: storeValues?.storeOmniData?.omni_new_drop
            },
            header: {},
            queryParams: {
                lob: userData?.lob,
                siNumber: userData?.rtn,
            },
        },
        type: 'apiCall',
    });

    onUserAction({ actions });
};

/**
 * create installation address object
 * @param {any} widgetAddressDetails
 * @returns {any}
 */
const createInstallationAddress = (widgetAddressDetails: any) => {
    const widgetAddressData = widgetAddressDetails?.widgetData
    if (widgetAddressDetails?.lob === "TELEMEDIA") {
        return {
            addressType: 'INSTALLATION',
            street1: widgetAddressData?.address?.addressString || '',
            city: widgetAddressData?.address?.city || '',
            postCode: widgetAddressData?.address?.pincode || '',
        }
    } else {
        return {
            addressType: 'INSTALLATION',
            street1: widgetAddressData?.addressString || '',
            city: widgetAddressData?.city || '',
            postCode: widgetAddressData?.pinCode || '',
            stateOrProvince: widgetAddressData?.pinCodeDetails?.state || ''
        }
    }
}